// for the new co2tabs
(function ($) {
    function changeViewOnMobile() {
        var ParentNav = $(".c02-tabs.tab-list-items-hotspot");
        ParentNav.each(function () {
            var childCount = $(this).find(".nav-tabs li").length;
            if (childCount > 2) {
                $(this).find(".nav-tabs").addClass('mobile-tabs');
            }
        });
        $(".mobile-tabs li").each(function (index, i) {
            $(this).attr("data-order", index);
        });
    }

    function mobileTabDropdown() {
        $('.nav-tabs.mobile-tabs .nav-item').off('click').on('click', function (e) {
            e.preventDefault();
            $('.nav-tabs.mobile-tabs .nav-item').toggleClass('visible-xs visible-sm');
            $('.nav-tabs.mobile-tabs .nav-item').toggleClass('elementDisplay');
            $('.nav-tabs.mobile-tabs .nav-item .tab-link').toggleClass('elementDisplay');
            e.stopPropagation();
            sortTabsForMobile();
            $(this).parent().prepend($(this));
            return;

        });
    }

    function sortTabsForMobile() {
        var list = document.getElementsByClassName("mobile-tabs");
        var items = list[0].childNodes;
        var itemsArr = [];

        for (var i in items) {
            if (items[i].nodeType == 1) { // Filter out text nodes
                itemsArr.push(items[i]);
            }
        }
        itemsArr.sort(function (a, b) {
            return a.getAttribute("data-order") - b.getAttribute("data-order");
        });

        for (i = 0; i < itemsArr.length; ++i) {
            list[0].appendChild(itemsArr[i]);
        }
    }

    $(document).ready(function () {

        if ($(window).width() < 821) {
            $(".mobile-tabs li").each(function (index, i) {
                $(this).attr("data-order", index);
            });
            changeViewOnMobile();
            mobileTabDropdown();
        } else {
            $(".nav-tabs").removeClass('mobile-tabs');
        }

    });
    $(window).resize(function () {
        if ($(window).width() < 821) {
            changeViewOnMobile();
            mobileTabDropdown();
        }
        else {
            $('.nav-tabs.mobile-tabs .nav-item').off();
        }
    });
    
    // added this for newherobanner componenet to make background dark when pop-up opens 
    $(document).ready(function () {
        if (document.querySelector('.videocontainer')) {
            document.body.classList.add('has-videocontainer');
        }
    });
}(window.jQuery));;



//from _custom-components.js
(function ($) {
    $(document).ready(function () {
        $('.tab-list-items-v2 .tab-link').each(function () {
            if ($(this).hasClass('active')) {
                $(this).attr("aria-pressed", 'true');
            }
        });

        $('.tab-list-items-v2 .tab-link').click(function () {
            $('.tab-list-items-v2 .tab-link').each(function () {
                $(this).attr("aria-pressed", 'false');
            });

            $(this).attr("aria-pressed", 'true');

            window.applyBreakpointsCss();

        });
    });

     //for removing tabindex from c02 tabs with arai-selected
     $(document).ready(function () {
        function removeTabindex() {
            $('.c02-tabs .option-list-items .nav-link, .c02-tabs .option-list-items .tab-link').removeAttr('tabindex');
        }
        removeTabindex();

        // Ensure tabindex is removed when any .nav-link is clicked
        $('.c02-tabs .option-list-items .nav-link, .c02-tabs .option-list-items .tab-link').on('click', function () {
            removeTabindex();
        });

        // Re-check and remove tabindex when window is fully loaded
        $(window).on('load', removeTabindex);

        // Continuously monitor changes and remove tabindex dynamically
        var observer = new MutationObserver(function () {
            removeTabindex();
        });

        // Observe the parent container for any DOM changes
        var targetNode = document.querySelector('.c02-tabs .option-list-items');

        if (targetNode) {
            // Observe the parent container for any DOM changes
            observer.observe(targetNode, {
                attributes: true,
                childList: true,
                subtree: true,
            });
        }
    });

}(window.jQuery));


// Analytics

analytics.eventConfig.push(
    {
        "target": ".component.c02-tabs",
        "events": [
            {
                "eventTarget": ".option-list-items:not(.tabicon-nav) .nav-item a.nav-link",
                "eventType": "click",
                "eventname": "C02_TabNavigationClick",
                "tags": {
                    "componentId": "c02",
                    "componentName": "tabs",
                    "elementText": "",
                    "elementType": "tab",
                    "event": "navigation",
                    "eventType": "tab click"
                }
            },

            {
                "eventTarget": ".option-list-items.tabicon-nav .nav-item a.nav-link",
                "eventType": "click",
                "tags": {
                    "componentId": "c02tic",
                    "componentName": "tabbed icon component",
                    "elementText": "",
                    "elementType": "tab icon",
                    "event": "navigation",
                    "eventType": "tab click",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": ".tabbedicon-content a:not([href*=\\http])",
                "eventType": "click",
                "tags": {
                    "componentId": "c02tic",
                    "componentName": "tabbed icon component",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "tab link",
                    "event": "navigation",
                    "eventType": "tab link internal navigation click",
                    "titleText": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": ".tabbedicon-content a[href*=\\http]",
                "eventType": "click",
                "tags": {
                    "componentId": "c02tic",
                    "componentName": "tabbed icon component",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "tab link",
                    "event": "outbound",
                    "eventType": "tab link outbound click",
                    "titleText": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": ""
                }
            },
            {
                "eventTarget": ".nav-tabs .nav-item .tab-link",
                "eventType": "click",
                "tags": {
                    "componentId": "c02",
                    "componentName": "tabs",
                    "destinationUrl": "",
                    "elementText": "",
                    "elementType": "tab",
                    "event": "navigation",
                    "eventType": "tab click",
                    "titleText": "",
                    "parentName": "",
                    "parentOrdinal": "",
                    "parentTitle": "",
                    "eventLabel": ""
                }
            }
        ]
    },
    
)
